/* ============================================================
   4o4 APPAREL . theme.js
   Runs on every page. Product markup is server-rendered (Liquid);
   this file only enhances what is already in the DOM, so every
   page-specific block is guarded and no-ops when its section is
   absent (product page, cart, 404, about, password).
   ============================================================ */
(function () {
  'use strict';

  /* ==========================================================
     environment
     ========================================================== */
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqTouch  = window.matchMedia('(hover: none)');
  var mqSmall  = window.matchMedia('(max-width: 600px)');
  var REDUCED  = mqReduce.matches;
  var TOUCH    = mqTouch.matches;

  var USE_CURSOR = !REDUCED && !TOUCH;
  if (!USE_CURSOR) document.documentElement.classList.add('no-cursor');

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  if (typeof gsap === 'undefined') return;   // CDN blocked: leave the plain HTML working
  gsap.registerPlugin(ScrollTrigger);

  /* ==========================================================
     1. boot loader  (lives in the layout, so present on every page)
     ========================================================== */
  var BOOT_LINES = [
    { text: '> booting 4o4 apparel',        tok: '' },
    { text: '> loading catalogue ...... ',  tok: 'ok' },
    { text: '> warming the press ...... ',  tok: 'ok' },
    { text: '> drop 001 archi ......... ',  tok: 'live' }
  ];

  /* The loader is an entry moment. The layout only renders #boot on the home
     template, so it never interrupts navigation to a product or cart page.
     Flip BOOT_ONCE_PER_SESSION to true to go back to showing it only on the
     first visit of a browser session. */
  var BOOT_ONCE_PER_SESSION = false;

  var boot = $('#boot');
  var bootDone = false;

  function removeBoot() { if (boot && boot.parentNode) boot.parentNode.removeChild(boot); }

  function dismissBoot() {
    if (bootDone) return;
    bootDone = true;
    try { sessionStorage.setItem('4o4_booted', '1'); } catch (e) {}
    startHero();

    /* The loader is a full-screen opaque panel, so its removal must never
       depend on an animation finishing. In a background tab the browser
       suspends rAF, the wipe tween stalls, onComplete never fires and the
       panel covers the whole site for as long as the tab stays open. Skip
       the wipe outright when hidden, and keep an unconditional timer as a
       backstop for any other reason the ticker is throttled. */
    if (!boot) return;
    if (REDUCED || document.hidden) { removeBoot(); return; }
    gsap.to(boot, { clipPath: 'inset(0 0 100% 0)', duration: 0.9, ease: 'power4.inOut', onComplete: removeBoot });
    setTimeout(removeBoot, 1400);
  }

  function runBoot() {
    var lines = $$('.line', boot);
    var caret = document.createElement('span');
    caret.className = 'caret';

    BOOT_LINES.forEach(function (L, i) {
      setTimeout(function () {
        if (bootDone || !lines[i]) return;
        var el = lines[i];
        var body = document.createElement('span');
        el.appendChild(body);
        el.appendChild(caret);

        var j = 0;
        var iv = setInterval(function () {
          if (bootDone) { clearInterval(iv); return; }
          body.textContent = L.text.slice(0, ++j);
          if (j >= L.text.length) {
            clearInterval(iv);
            if (L.tok) {
              var tok = document.createElement('span');
              tok.className = 'tok';
              el.insertBefore(tok, caret);
              var k = 0;
              var iv2 = setInterval(function () {
                if (bootDone) { clearInterval(iv2); return; }
                tok.textContent = L.tok.slice(0, ++k);
                if (k >= L.tok.length) {
                  clearInterval(iv2);
                  if (i === BOOT_LINES.length - 1) setTimeout(dismissBoot, 420);
                }
              }, 12);
            } else if (i === BOOT_LINES.length - 1) {
              setTimeout(dismissBoot, 420);
            }
          }
        }, 12);
      }, i * 220);
    });

    setTimeout(dismissBoot, 2600); // hard cap
  }

  /* ==========================================================
     2. hero text scramble
     ========================================================== */
  var SCRAMBLE_CHARS = '!<>-_\\/[]{}=+*^?#';

  function scrambleEl(el, delayBase) {
    var chars = el.textContent.split('');
    var spans = chars.map(function (c) {
      var s = document.createElement('span');
      s.textContent = c === ' ' ? ' ' : c;
      return s;
    });
    el.textContent = '';
    spans.forEach(function (s) { el.appendChild(s); });

    var start = -1;
    var queue = chars.map(function (c, i) {
      return { c: c, from: delayBase + i * 26, to: delayBase + i * 26 + 360, span: spans[i] };
    });

    function tick(time) {
      var now = time * 1000;
      if (start < 0) start = now;
      var t = now - start;
      var done = 0;
      for (var i = 0; i < queue.length; i++) {
        var q = queue[i];
        if (q.c === ' ') { done++; continue; }
        if (t >= q.to) {
          if (q.span.textContent !== q.c) q.span.textContent = q.c;
          done++;
        } else if (t >= q.from) {
          if (Math.random() < 0.32 || q.span.dataset.s !== '1') {
            q.span.textContent = SCRAMBLE_CHARS[(Math.random() * SCRAMBLE_CHARS.length) | 0];
            q.span.dataset.s = '1';
          }
        } else {
          q.span.textContent = ' ';
        }
      }
      if (done >= queue.length) gsap.ticker.remove(tick);
    }
    gsap.ticker.add(tick);
  }

  var heroStarted = false;
  function startHero() {
    if (heroStarted) return;
    heroStarted = true;
    if (!$('#hero')) return;

    if (REDUCED) {
      if ($('#hero .hero-inner')) gsap.fromTo('#hero .hero-inner', { opacity: 0 }, { opacity: 1, duration: 0.4 });
      return;
    }
    $$('#hero .scramble').forEach(function (el, i) { scrambleEl(el, i * 180); });

    var fadeIn = $$('#hero .eyebrow, #hero .hero-sub, #hero .hero-cta, #hero .scroll-cue');
    if (fadeIn.length) {
      gsap.fromTo(fadeIn, { opacity: 0, y: 14 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', stagger: 0.08, delay: 0.25 });
    }
    /* Fade the inner <img>, not the .chip wrapper: each wrapper carries its own
       per-chip opacity in CSS, so animating the wrapper would clobber it. */
    var chipImgs = $$('#hero .chip img');
    if (chipImgs.length) gsap.fromTo(chipImgs, { opacity: 0 }, { opacity: 1, duration: 1.2, ease: 'power2.out', delay: 0.4 });
  }

  /* ==========================================================
     smooth scroll + one clock
     ========================================================== */
  var lenis = null;
  var scrollY = window.scrollY || 0;

  if (!REDUCED && typeof Lenis !== 'undefined') {
    /* Lenis drives the native window scroll, so ScrollTrigger needs no
       scrollerProxy; it only needs updating from Lenis and the same clock. */
    lenis = new Lenis({
      duration: 1.1,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      syncTouch: false
    });
    lenis.on('scroll', function (e) { scrollY = e.scroll; ScrollTrigger.update(); });
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  } else {
    window.addEventListener('scroll', function () { scrollY = window.scrollY; }, { passive: true });
  }

  /* ==========================================================
     header
     ========================================================== */
  var head = $('.site-head');
  if (head) {
    ScrollTrigger.create({
      start: 40,
      onUpdate: function (self) { head.classList.toggle('is-stuck', self.scroll() > 40); },
      onRefresh: function (self) { head.classList.toggle('is-stuck', self.scroll() > 40); }
    });
  }

  /* ==========================================================
     mobile nav
     ========================================================== */
  var menuBtn = $('.menu-btn');
  var mnav = $('#mnav');
  if (menuBtn && mnav) {
    var mclose = $('.mclose', mnav);
    var closeMenu = function () {
      mnav.classList.remove('is-open');
      mnav.setAttribute('aria-hidden', 'true');
      menuBtn.setAttribute('aria-expanded', 'false');
      menuBtn.focus();
      if (lenis) lenis.start();
    };
    menuBtn.addEventListener('click', function () {
      mnav.classList.add('is-open');
      mnav.setAttribute('aria-hidden', 'false');
      menuBtn.setAttribute('aria-expanded', 'true');
      if (mclose) mclose.focus();
      if (lenis) lenis.stop();
    });
    if (mclose) mclose.addEventListener('click', closeMenu);
    $$('a', mnav).forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.classList.contains('is-open')) closeMenu();
    });
  }

  /* in-page anchors routed through Lenis; real routes are left alone */
  $$('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = $(id);
      if (!t) return;
      e.preventDefault();
      if (lenis) lenis.scrollTo(t, { offset: -70 });
      else t.scrollIntoView({ block: 'start' });
    });
  });

  /* ==========================================================
     marquee
     ========================================================== */
  var MARQUEE = ['made to order', 'zero inventory', 'heavyweight cotton', 'ships worldwide', 'drop 001 archi', 'make tech less boring'];
  var mqTrack = $('.mq-track');
  var mqTween = null;

  /* The track holds the sequence twice, so translating by exactly half its
     width and repeating loops seamlessly. Width is measured here and on
     resize only, never inside the tween: a per-frame scrollWidth read forces
     synchronous layout every frame and destroys the frame budget. */
  function buildMarquee() {
    if (!mqTrack) return;
    if (mqTween) mqTween.kill();
    gsap.set(mqTrack, { x: 0 });
    var half = mqTrack.scrollWidth / 2;
    if (!half) return;
    mqTween = gsap.to(mqTrack, { x: -half, duration: mqSmall.matches ? 28 : 42, ease: 'none', repeat: -1 });
  }

  if (mqTrack) {
    var seq = MARQUEE.map(function (m) { return '<span>' + m + '<i>&#9702;</i></span>'; }).join('');
    mqTrack.innerHTML = seq + seq;
    buildMarquee();
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (mqTween) { en.isIntersecting ? mqTween.play() : mqTween.pause(); } });
    }, { rootMargin: '80px' }).observe(mqTrack.parentNode);
  }

  /* ==========================================================
     drop gallery: pin + scrub (desktop, motion allowed)
     ========================================================== */
  var dropTrack = $('.drop-track');
  var railFill = $('.drop-rail i');

  if (dropTrack && $('#drop')) {
    gsap.matchMedia().add('(min-width: 901px) and (prefers-reduced-motion: no-preference)', function () {
      gsap.to(dropTrack, {
        x: function () { return -(dropTrack.scrollWidth - window.innerWidth + 120); },
        ease: 'none',
        scrollTrigger: {
          trigger: '#drop', start: 'top top', end: '+=180%',
          pin: true, scrub: 1, anticipatePin: 1, invalidateOnRefresh: true,
          onUpdate: function (self) {
            if (railFill) railFill.style.transform = 'scaleX(' + self.progress.toFixed(4) + ')';
          }
        }
      });
      /* Do NOT kill the tween/ScrollTrigger by hand here. gsap.matchMedia()
         already reverts everything created inside this context when the query
         stops matching, and a manual .kill() pre-empts that revert, orphaning
         the pin-spacer with its inline width and padding still applied. That
         leaks a wide scroll box and breaks every layout under 901px. Only
         reset state matchMedia does not own. */
      return function () { if (railFill) railFill.style.transform = 'scaleX(0)'; };
    });
  }

  /* ==========================================================
     scroll reveals
     ========================================================== */
  /* Reveal-on-scroll as progressive enhancement.

     The earlier version pre-hid every .card and .step with opacity:0 and relied
     on a tween to bring them back. If that tween never ran (throttled ticker in
     a background tab, a ScrollTrigger that fires onEnter while the ticker is
     asleep, a slow device) the content stayed invisible forever. That emptied
     the whole process section on /pages/about and would have hidden all 17
     product cards on the home page.

     Rules now: never hide anything already on screen, and run a failsafe that
     force-shows anything visible-but-still-transparent. Off-screen items keep
     their stagger. */
  function revealOnScroll(els, dy, stagger) {
    if (!els.length) return;
    if (REDUCED) { gsap.set(els, { opacity: 1, y: 0 }); return; }

    var vh = window.innerHeight;
    var below = els.filter(function (el) { return el.getBoundingClientRect().top > vh * 0.9; });
    var onscreen = els.filter(function (el) { return below.indexOf(el) === -1; });

    if (onscreen.length) gsap.set(onscreen, { opacity: 1, y: 0 });
    if (!below.length) return;

    gsap.set(below, { opacity: 0, y: dy });
    ScrollTrigger.batch(below, {
      start: 'top 92%', once: true,
      onEnter: function (b) { gsap.to(b, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out', stagger: stagger }); }
    });

    var pending = below.slice();
    function failsafe() {
      var h = window.innerHeight;
      pending = pending.filter(function (el) {
        if (parseFloat(getComputedStyle(el).opacity) > 0.99) return false;
        var r = el.getBoundingClientRect();
        if (r.top < h && r.bottom > 0) { gsap.set(el, { opacity: 1, y: 0 }); return false; }
        return true;
      });
      if (!pending.length && timer) { clearInterval(timer); timer = null; }
    }
    var timer = setInterval(failsafe, 1200);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) failsafe(); });
    window.addEventListener('load', failsafe);
  }

  var cardEls = $$('.card');
  revealOnScroll(cardEls, 26, 0.06);

  var procLine = $('.proc-line');
  if (procLine) {
    gsap.to(procLine, {
      scaleX: 1, duration: 1.1, ease: 'power2.out',
      scrollTrigger: { trigger: '.proc-row', start: 'top 78%', once: true }
    });
  }
  revealOnScroll($$('.step'), 20, 0.07);

  /* ==========================================================
     stats count-up
     ========================================================== */
  $$('.fig').forEach(function (el) {
    var end = parseFloat(el.getAttribute('data-count'));
    if (isNaN(end)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var obj = { v: 0 };
    ScrollTrigger.create({
      trigger: el, start: 'top 88%', once: true,
      onEnter: function () {
        gsap.to(obj, {
          v: end, duration: 1.6, ease: 'power2.out',
          onUpdate: function () { el.textContent = Math.round(obj.v) + suffix; }
        });
      }
    });
  });

  /* ==========================================================
     pointer-driven motion: ONE loop, no layout reads inside
     ========================================================== */
  var px = window.innerWidth / 2, py = window.innerHeight / 2;
  var cx = px, cy = py, dx = px, dy = py;
  var hasPointer = false;

  var cursorEl = $('#cursor');
  var dotEl = $('#cursor-dot');

  window.addEventListener('pointermove', function (e) {
    px = e.clientX; py = e.clientY;
    if (!hasPointer) {
      hasPointer = true;
      cx = dx = px; cy = dy = py;
      if (USE_CURSOR && cursorEl && dotEl) { cursorEl.style.opacity = '1'; dotEl.style.opacity = '1'; }
    }
  }, { passive: true });

  if (USE_CURSOR && cursorEl) {
    document.addEventListener('pointerover', function (e) {
      var hot = e.target.closest && e.target.closest('a, button, .card, [data-cursor]');
      if (!hot) return;
      cursorEl.classList.add('is-hot');
      if (hot.matches('[data-cursor="view"]')) cursorEl.classList.add('is-view');
    });
    document.addEventListener('pointerout', function (e) {
      var hot = e.target.closest && e.target.closest('a, button, .card, [data-cursor]');
      if (!hot) return;
      if (e.relatedTarget && hot.contains(e.relatedTarget)) return;
      cursorEl.classList.remove('is-hot', 'is-view');
    });
  }

  var magnets = $$('[data-magnetic]').map(function (el) {
    return { el: el, fixed: !!el.closest('.site-head'), cx: 0, cy: 0, x: 0, y: 0, tx: 0, ty: 0, promoted: false };
  });

  var cards = cardEls.map(function (el) {
    return {
      el: el, l: 0, t: 0, w: 0, h: 0,
      rx: 0, ry: 0, trx: 0, try_: 0,
      mx: 50, my: 50, tmx: 50, tmy: 50,
      hovered: false, active: false
    };
  });
  var gridVisible = true;

  cards.forEach(function (c) {
    c.el.addEventListener('pointerenter', function () {
      if (REDUCED || TOUCH) return;
      c.hovered = true;
      if (!c.active) { c.active = true; c.el.style.willChange = 'transform'; }
    });
    c.el.addEventListener('pointerleave', function () { c.hovered = false; });
  });

  var CHIP_CFG = [
    { mult: 18,  ax: 10, ay: 16, per: 9.0,  ph: 0.0 },
    { mult: -12, ax: 10, ay: 16, per: 11.5, ph: 1.7 },
    { mult: 22,  ax: 10, ay: 16, per: 12.8, ph: 3.1 },
    { mult: -9,  ax: 10, ay: 16, per: 14.0, ph: 4.6 }
  ];
  var chips = $$('#hero .chip').map(function (el, i) {
    return { el: el, cfg: CHIP_CFG[i % CHIP_CFG.length], x: 0, y: 0 };
  });
  var heroVisible = true;

  /* glyph field */
  var glyphCanvas = $('#glyphs');
  var gctx = glyphCanvas ? glyphCanvas.getContext('2d', { alpha: true }) : null;
  var GLYPH_SET = '01<>/{}[];=+*#$404';
  var glyphs = [];
  var gW = 0, gH = 0, gDrift = 0, gTotalH = 0;
  var heroRectTop = 0, heroRectLeft = 0;
  var GLYPHS_ON = !!gctx && !REDUCED && !TOUCH && !mqSmall.matches;
  var GLYPH_CAP = 520;   // hard ceiling on fillText calls per draw
  var gFrameSkip = 0;    // canvas redraws at ~30fps; the drift is slow enough to read identically

  function buildGlyphs() {
    glyphs = [];
    if (!GLYPHS_ON) return;
    var hero = $('#hero');
    if (!hero) return;
    gW = hero.offsetWidth;
    gH = hero.offsetHeight;
    if (!gW || !gH) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    glyphCanvas.width = Math.round(gW * dpr);
    glyphCanvas.height = Math.round(gH * dpr);
    gctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    gctx.font = "11px 'JetBrains Mono', ui-monospace, monospace";
    gctx.textBaseline = 'top';

    var cellX = 32, cellY = 30;
    var cols = Math.ceil(gW / cellX);
    var rows = Math.ceil(gH / cellY) + 1;
    while (cols * rows > GLYPH_CAP) { cellX += 2; cellY += 2; cols = Math.ceil(gW / cellX); rows = Math.ceil(gH / cellY) + 1; }

    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        glyphs.push({ bx: c * cellX + 6, by: r * cellY, ch: GLYPH_SET[(Math.random() * GLYPH_SET.length) | 0], ox: 0, oy: 0, a: 0.12 });
      }
    }
    gTotalH = rows * cellY;
  }

  /* rect cache: the ONLY place layout is read for the loop */
  function cacheRects() {
    var sx = window.scrollX, sy = window.scrollY;
    magnets.forEach(function (m) {
      var r = m.el.getBoundingClientRect();
      if (m.fixed) { m.cx = r.left + r.width / 2; m.cy = r.top + r.height / 2; }
      else { m.cx = r.left + r.width / 2 + sx; m.cy = r.top + r.height / 2 + sy; }
    });
    cards.forEach(function (c) {
      var r = c.el.getBoundingClientRect();
      c.l = r.left + sx; c.t = r.top + sy; c.w = r.width; c.h = r.height;
    });
    var hero = $('#hero');
    if (hero) {
      var hr = hero.getBoundingClientRect();
      heroRectLeft = hr.left + sx;
      heroRectTop = hr.top + sy;
    }
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      buildGlyphs();
      buildMarquee();
      cacheRects();
      /* No ScrollTrigger.refresh() here. ScrollTrigger refreshes itself on
         resize and gsap.matchMedia() re-evaluates its queries on the same
         event. Forcing a refresh mid-revert races that teardown and leaves
         the pinned context permanently reverted, so the drop gallery never
         re-pins when the viewport crosses back above 901px. Rects are
         re-cached from ScrollTrigger's own 'refresh' event instead. */
    }, 180);
  });
  ScrollTrigger.addEventListener('refresh', cacheRects);

  var heroEl = $('#hero');
  if (heroEl) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        heroVisible = e.isIntersecting;
        /* chips animate continuously, but only while the hero is on screen */
        for (var i = 0; i < chips.length; i++) chips[i].el.style.willChange = heroVisible ? 'transform' : '';
      });
    }, { rootMargin: '100px' }).observe(heroEl);
  }
  var gridSection = $('#grid');
  if (gridSection) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { gridVisible = e.isIntersecting; });
    }, { rootMargin: '160px' }).observe(gridSection);
  }

  var lastAlphaKey = -1;

  function pointerFrame(time, delta) {
    if (document.hidden) return;
    var dt = Math.min(delta, 50) / 1000;

    /* cursor */
    if (USE_CURSOR && hasPointer && cursorEl && dotEl) {
      dx += (px - dx) * 0.35;
      dy += (py - dy) * 0.35;
      cx += (px - cx) * 0.14;
      cy += (py - cy) * 0.14;
      var s = cursorEl.classList.contains('is-hot') ? 2.1 : 1;
      cursorEl.style.transform = 'translate3d(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px,0) scale(' + s + ')';
      dotEl.style.transform = 'translate3d(' + dx.toFixed(2) + 'px,' + dy.toFixed(2) + 'px,0)';
    }

    /* magnetic */
    if (!REDUCED && !TOUCH) {
      for (var i = 0; i < magnets.length; i++) {
        var m = magnets[i];
        var mvy = m.fixed ? m.cy : m.cy - scrollY;
        var ddx = px - m.cx, ddy = py - mvy;
        var dist = Math.sqrt(ddx * ddx + ddy * ddy);
        if (dist < 70) {
          if (!m.promoted) { m.promoted = true; m.el.style.willChange = 'transform'; }
          m.tx = Math.max(-12, Math.min(12, ddx * 0.28));
          m.ty = Math.max(-12, Math.min(12, ddy * 0.28));
        } else { m.tx = 0; m.ty = 0; }
        m.x += (m.tx - m.x) * 0.16;
        m.y += (m.ty - m.y) * 0.16;
        if (Math.abs(m.x) > 0.01 || Math.abs(m.y) > 0.01) {
          m.el.style.transform = 'translate3d(' + m.x.toFixed(2) + 'px,' + m.y.toFixed(2) + 'px,0)';
        } else if (m.promoted) {
          m.el.style.transform = '';
          m.promoted = false;
          m.el.style.willChange = '';
        }
      }
    }

    /* card tilt + specular */
    if (!REDUCED && !TOUCH && gridVisible) {
      for (var k = 0; k < cards.length; k++) {
        var c = cards[k];
        if (!c.active) continue;
        if (c.hovered) {
          var rx = (px - c.l);
          var ry = (py - (c.t - scrollY));
          var nx = (rx / c.w) - 0.5;
          var ny = (ry / c.h) - 0.5;
          c.trx = -ny * 12;              // max 6deg each way
          c.try_ = nx * 12;
          c.tmx = Math.max(0, Math.min(100, (rx / c.w) * 100));
          c.tmy = Math.max(0, Math.min(100, (ry / c.h) * 100));
        } else { c.trx = 0; c.try_ = 0; }
        c.rx += (c.trx - c.rx) * 0.12;
        c.ry += (c.try_ - c.ry) * 0.12;
        c.mx += (c.tmx - c.mx) * 0.12;
        c.my += (c.tmy - c.my) * 0.12;
        c.el.style.transform = 'perspective(900px) rotateX(' + c.rx.toFixed(3) + 'deg) rotateY(' + c.ry.toFixed(3) + 'deg) translateZ(0)';
        c.el.style.setProperty('--mx', c.mx.toFixed(1) + '%');
        c.el.style.setProperty('--my', c.my.toFixed(1) + '%');
        if (!c.hovered && Math.abs(c.rx) < 0.02 && Math.abs(c.ry) < 0.02) {
          c.active = false;
          c.rx = c.ry = 0;
          c.el.style.transform = '';
          c.el.style.willChange = '';
        }
      }
    }

    /* hero chips + glyph field */
    if (heroVisible && !REDUCED && !TOUCH) {
      for (var q = 0; q < chips.length; q++) {
        var ch = chips[q], cf = ch.cfg;
        var sx2 = Math.sin((time / cf.per) * Math.PI * 2 + cf.ph) * cf.ax;
        var sy2 = Math.cos((time / cf.per) * Math.PI * 2 + cf.ph) * cf.ay;
        var pxn = (px / window.innerWidth) - 0.5;
        var pyn = (py / window.innerHeight) - 0.5;
        ch.x += ((sx2 + pxn * cf.mult) - ch.x) * 0.06;
        ch.y += ((sy2 + pyn * cf.mult) - ch.y) * 0.06;
        ch.el.style.transform = 'translate3d(' + ch.x.toFixed(2) + 'px,' + ch.y.toFixed(2) + 'px,0)';
      }

      if (GLYPHS_ON && glyphs.length && (gFrameSkip = (gFrameSkip + 1) & 1) === 0) {
        gDrift = (gDrift + 6 * dt * 2) % gTotalH;
        gctx.clearRect(0, 0, gW, gH);
        var lpx = px - heroRectLeft;
        var lpy = py - (heroRectTop - scrollY);
        lastAlphaKey = -1;
        for (var g = 0; g < glyphs.length; g++) {
          var gl = glyphs[g];
          var gy = gl.by - gDrift;
          if (gy < -20) gy += gTotalH;
          var vdx = gl.bx - lpx, vdy = gy - lpy;
          var d2 = vdx * vdx + vdy * vdy;
          var tox = 0, toy = 0, ta = 0.12;
          if (d2 < 25600) {                       // 160px radius
            var d = Math.sqrt(d2) || 1;
            var f = 1 - d / 160;
            tox = (vdx / d) * 14 * f;
            toy = (vdy / d) * 14 * f;
            ta = 0.12 + 0.48 * f;
          }
          gl.ox += (tox - gl.ox) * 0.08;
          gl.oy += (toy - gl.oy) * 0.08;
          gl.a += (ta - gl.a) * 0.08;
          var key = (gl.a * 20) | 0;
          if (key !== lastAlphaKey) { gctx.fillStyle = 'rgba(63,185,80,' + (key / 20).toFixed(2) + ')'; lastAlphaKey = key; }
          gctx.fillText(gl.ch, gl.bx + gl.ox, gy + gl.oy);
        }
      }
    }
  }

  if (!REDUCED) gsap.ticker.add(pointerFrame);

  /* ==========================================================
     init
     ========================================================== */
  buildGlyphs();
  cacheRects();

  var alreadyBooted = false;
  if (BOOT_ONCE_PER_SESSION) {
    try { alreadyBooted = sessionStorage.getItem('4o4_booted') === '1'; } catch (e) {}
  }

  if (!boot || alreadyBooted || REDUCED) {
    removeBoot();
    bootDone = true;
    startHero();
  } else {
    runBoot();
  }

  window.addEventListener('load', function () {
    buildGlyphs();
    buildMarquee();
    cacheRects();
    ScrollTrigger.refresh();
  });

})();
